export const primaryColor = "#2a2a86";
export const whiteColor = "#ffffff";
export const blackColor = "#000000";
export const borderColor = "#d9d9d9";

export const colorSuccess = "#52C41A";
export const backgroundColorSuccess = "#F6FFED";
export const borderColorSuccess = "#B7EB8F";

export const colorWrongFormat = "#2A2A86";
export const backgroundColorWrongFormat = "#F0F0FE";
export const borderColorWrongFormat = "#B0B0F2";

export const colorFailed = "#F5222D";
export const backgroundColorFailed = "#FFF1F0";
export const borderColorFailed = "#FFA39E";
